// export const THEME1URL = "/theme1/:restaurantname";
// export const THEME2URL = "/theme2";
export const HOME = "/";
export const HOME_V2 = "/v2";
export const HOME_V3 = "/v3";
export const HOME_V4 = "/v4";
export const ADMINSIGNIN = "/login";
export const RESTAURANTDASH = "/restaurant/admin";
export const SUPERADMIN = "/superadmin";
export const RESTAURANT = "/:restaurantName";
export const NOTFOUND = "/error/notfound";
export const NOTSUBSCRIBED = "/notsubscribed";
export const SALESDASH = "/sales/dashboard";
